// eslint-disable-next-line import/no-default-export -- legacy usage
export { default } from "./CollapseSection";
